<template>
	<SectionCard>
		<template #title>
			Properties
		</template>
		<template #body>
			<v-row dense>
				<v-col cols="6">
					<TextField
						:value.sync="preferenceWidget.sourceCode"
						label="Source Code"
						maxlength="50"
						counter="50"
						:disabled="!userFullPermissions"
						tooltip-text="<p>Input your default Source Code text. This value can be overwritten dynamically if you set and include this field in your form</p><p>This data will be stored against the Preference update for the Data Subject in question and can be used to determine the source of the transaction if the embedded consent collection code is used in multiple locations</p>"
						@input="updatePreferenceWidget('sourceCode', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="6">
					<TextField
						:value.sync="preferenceWidget.responseChannel"
						label="Response Channel"
						maxlength="50"
						counter="50"
						:disabled="!userFullPermissions"
						tooltip-text="<p>Input your default Response Channel text. This value can be overwritten dynamically if you set and include this field in your form</p><p>This data will be stored against the Preference update for the Data Subject in question and can be used to determine the source of the transaction if the embedded consent collection code is used in multiple locations</p>"
						@input="updatePreferenceWidget('responseChannel', $event)"
					/>
				</v-col>
			</v-row>
		</template>
	</SectionCard>
</template>

<script>
import SectionCard from '../../../../../shared/components/section-card.vue'
import TextField from '../../../../../shared/components/text-field.vue'

export default {
	components: {
		SectionCard,
		TextField
	},
	props: {
		preferenceWidget: {
			type: Object,
			required: true
		},
		updatePreferenceWidget: {
			type: Function,
			required: true
		},
		userFullPermissions: Boolean
	}
}
</script>
